<template>
  <div :class="['v-card__actions--group', getSelectedDEV && 'dev-selected-component', attributes.class && attributes.class ]">
    <template v-for="(action, index) in actions">
      <v-tooltip bottom :color="action.tooltipColorClass" :key="index" :disabled="!action.tooltip">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :data-has-tooltip="action.tooltip || action.label ? 'true' : 'false'"
            :data-tooltip="action.tooltip || action.label"
            :key="index"
            :disabled="action.readonly"
            :name="action.name"
            :id="action.id"
            v-bind="[attributes, action.attributes, attrs]"
            v-on="on"
            @contextmenu="selectComponentDEV($event, schema.model)"
            @click="execute(action)"
            class="i4pro-button-template"
          >
            <v-icon
              v-if="action.attributesIcon.icon && !action.attributesIcon.right"
              v-bind="action.attributesIcon"
              class="mr-1"
              >{{ action.attributesIcon.icon }}</v-icon
            >
            {{ action.label }}
            <v-icon
              v-if="action.attributesIcon.icon && action.attributesIcon.right"
              v-bind="action.attributesIcon"
              class="ml-1"
              >{{ action.attributesIcon.icon }}</v-icon
            >
          </v-btn>
        </template>
        <span>{{ action.tooltip }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import store from '@/store';

import * as HANDLERS from '@/helpers/types/handlers';
import devComponentMixin from '@/mixins/dev-component-mixin';
import actionDefault from '@/mixins/action-default';

export default {
  mixins: [devComponentMixin, actionDefault],

  props: {
    actions: { type: Array, required: true },
    mode: { type: String, required: true },
    page: { type: String, required: true },
    step: { type: Number, required: false },
    attributes: { type: Object, default: () => ({}), required: true },
    schema: { type: Object, default: () => ({}) }
  },

  data: () => ({
    actionName: ''
  }),

  events: {
    [HANDLERS.ACTION_DEFAULT]: 'executeActionDefault'
  },

  methods: {
    execute(action) {
      action.mode = this.mode;

      this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.page, step: this.step });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-toolbar__items {
  .v-card__actions--group {
    align-items: center;
    align-self: center;
    height: 100%;
    max-height: 100%;

    .v-btn {
      height: inherit;
    }
  }
}
</style>
